import { useTranslation } from "react-i18next";
import { Link } from "react-router";

export function LandingFooter() {
  const { t } = useTranslation("landing");
  const year = new Date().getFullYear();

  const productLinks = [
    { labelKey: "nav.features", href: "#features" },
    { labelKey: "nav.how", href: "#how" },
  ];

  return (
    <footer className="relative border-t border-[#1B2622] bg-[#070A0B] text-[#E2EDE7]">
      <div className="mx-auto max-w-[1320px] px-6 py-14 lg:px-10">
        <div className="grid gap-12 md:grid-cols-[2fr_1fr_1fr]">
          <div>
            <Link to="/" className="inline-block" aria-label="Forecast Engine — home">
              <img
                src="/logo-forecast-engine.svg"
                alt="Forecast Engine — train · predict · deliver"
                width={300}
                height={128}
                loading="lazy"
                className="h-auto w-full max-w-[300px]"
              />
            </Link>
            <p className="mt-5 max-w-sm text-[13.5px] leading-[1.7] text-[#788A82]">
              {t("meta.description")}
            </p>
          </div>

          <div>
            <h3 className="mono-label">{t("footer.product")}</h3>
            <ul className="mt-4 space-y-3">
              {productLinks.map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="bp-mono text-[13px] uppercase tracking-[0.08em] text-[#9DACA4] transition-colors hover:text-[#4CD6C4]">
                    {t(l.labelKey)}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="mono-label">{t("footer.legal")}</h3>
            <ul className="mt-4 space-y-3">
              <li>
                <Link to="/impressum" className="bp-mono text-[13px] uppercase tracking-[0.08em] text-[#9DACA4] transition-colors hover:text-[#4CD6C4]">
                  {t("footer.impressum")}
                </Link>
              </li>
              <li>
                <Link to="/datenschutz" className="bp-mono text-[13px] uppercase tracking-[0.08em] text-[#9DACA4] transition-colors hover:text-[#4CD6C4]">
                  {t("footer.datenschutz")}
                </Link>
              </li>
              <li>
                <Link to="/agb" className="bp-mono text-[13px] uppercase tracking-[0.08em] text-[#9DACA4] transition-colors hover:text-[#4CD6C4]">
                  {t("footer.agb")}
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex items-center gap-3 border-t border-[#1B2622] pt-6">
          <span className="bp-dot" aria-hidden />
          <span className="bp-mono text-[11px] uppercase tracking-[0.16em] text-[#788A82]">
            {t("footer.rights", { year })}
          </span>
        </div>
      </div>
    </footer>
  );
}

export default LandingFooter;
